import { Component, Input, OnInit } from '@angular/core';
import { PlanResponse } from 'src/app/core/model/v1.model';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  @Input() product;

  constructor() { }

  ngOnInit(): void {
  }

}
